<template>
  <div>
    <v-card class="rounded-lg" elevation="2">
      <v-tabs fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="#FFFFFF"></v-tabs-slider>
        <v-tab><v-icon style="padding:10px">mdi-account-search</v-icon>{{ title }}</v-tab>
        <v-tab-item>
          <v-card-text>
            <v-row dense class="justify-end">
              <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="rounded-lg" elevation="1" color="#aab5b0" dark v-bind="attrs" v-on="on">
                    <v-icon class="mr-2" color="#FFFFFF">mdi-filter</v-icon>
                    <span class="textBtn">FILTRO</span>
                  </v-btn>
                </template>

                <v-card class="rounded-lg">
                  <v-list dense class="text-center w-full text-xs font-medium">
                    <span>Selecione os Filtros</span>
                  </v-list>

                  <div class="overflow-y-auto gap-0 flex-1">
                    <v-list>
                      <v-list-item>
                        <v-text-field color="#086318" label="Nome" placeholder="Nome completo" class="rounded-lg"
                          outlined v-model="serologySearch.name" hide-details dense></v-text-field>
                      </v-list-item>
                      <v-list-item>
                        <v-autocomplete :items="unities" label="Hospital Notificante" class="rounded-lg" color="#086318"
                          v-model="serologySearch.unity" item-value="id" item-text="hospital" hide-details dense
                          outlined>
                        </v-autocomplete>
                      </v-list-item>
                      <v-list-item>
                        <v-select :items="kind_of_donor" label="Situação do Paciente" class="rounded-lg" color="#086318"
                          v-model="serologySearch.kind_of_donor" item-value="id" item-text="name" dense hide-details
                          outlined>
                        </v-select>
                      </v-list-item>
                      <v-list-item>
                        <v-autocomplete :items="factors" label="Fator RH" class="rounded-lg" color="#086318"
                          v-model="serologySearch.factor" item-value="id" item-text="description" dense hide-details
                          outlined>
                        </v-autocomplete>
                      </v-list-item>
                    </v-list>
                  </div>

                  <v-card-actions class="justify-center"> 
                    <v-btn class="rounded-lg" @click="menu = false" small>
                      {{$t('buttons.cancel')}}
                    </v-btn>
                    <v-btn small color="#aab5b0" class="rounded-lg" :loading="loadingTrashButton"
                      @click="clear()" dark>
                      {{$t('buttons.clean_up')}}
                    </v-btn>
                    <v-btn class="rounded-lg" color="#41916b" small dark :loading="loadingBTN"
                      @click="search(), loadingBTN = true, loading = true">
                      <v-icon color="#FFFFFF">mdi-magnify</v-icon>
                      {{$t('buttons.search')}}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-btn class="rounded-lg ml-1" elevation="0" color="#41916b" @click="dialog = true, currentPatient = {}">
                <span class="textBtn"><v-icon>mdi-plus</v-icon>{{$t('buttons.new')}}</span>
              </v-btn>
            </v-row>
          </v-card-text>

          <v-data-table :headers="headers" :items="items"
            :footer-props="{ 'items-per-page-text': 'Grupo Sanguíneo por Página', }" :page="page" :loading="loading">
            <template #no-data>
              <div class="text-center py-4">Nenhum Grupo Sanguíneo encontrado</div>
            </template>
            <template v-slot:[`item.quantity_of_exams`]="{ item }">
              {{ getQuantityOfExams(item) }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu left :offset-x="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon size="22" class="icon" color="#41916b" v-on="on" v-bind="attrs">
                    mdi-cog
                  </v-icon>
                </template>

                <v-list density="compact">
                  <span class="d-flex justify-center">Menu de Ações</span>

                  <v-list-item v-for="(menuItem, i) in menuItems" :key="i" :value="menuItem" color="primary"
                    @click="setAction(menuItem, item), currentPatient = item">
                    <template v-slot:prepend>

                    </template>

                    <span> <v-icon size="20" class="mr-2">{{ menuItem.icon }}</v-icon>{{ menuItem.title }}</span>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:[`item.fator_rh`]="{ item }">
              <v-chip color="#e85454" class="ml-1" v-for="blood_group in item.blood_groups" :key="blood_group">
                <v-icon size="20" class="mr-2" color="#ffffff">mdi-water</v-icon>
                <span style="color:#ffffff">{{ blood_group.blood_factor.description }}</span>
              </v-chip>
            </template>

            <template v-slot:[`item.sample_date`]="{ item }">
              <div class="d-flex flex-column align-center">
                <span v-for="blood_group in item.blood_groups" :key="blood_group.id">
                  {{ formatDate(blood_group.sample_date) }}
                </span>
              </div>
            </template>

            <template v-slot:[`item.release_date`]="{ item }">
              <div class="d-flex flex-column align-center">
                <span v-for="blood_group in item.blood_groups" :key="blood_group.id">
                  {{ formatDate(blood_group.release_date) }}
                </span>
              </div>
            </template>
          </v-data-table>

          <v-overlay :value="loadingPDF">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="500px" class="rounded-lg">
      <v-card class="rounded-lg pa-4">
        <BloodGroup @closeDialog="dialog = $event" :resource="currentPatient" @reloadGrid="handleReload" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { mapActions } from "vuex";
import { getBloodList, getUnities, getPatienteSituations, getFactors } from "@/service/SerologyService";
import BloodGroup from "./BloodGroup.vue";
import currentUser from "@/utils/currentUser";
import { profileSlug } from "@/helpers/profileSlug";
export default {
  data() {
    return {
      menu: false,
      dialog: false,
      title: "Pacientes com Grupos Sanguíneos",
      headersForAll: [
        {
          text: "Situação do Paciente",
          align: "center",
          value: "kind_of_donor.name",
        },
        {
          text: "Paciente",
          align: "start",
          value: "name",
        },
        {
          text: "Hospital Notificante",
          align: "start",
          value: "unities.hospital",
        },
        {
          text: "Quantidade de Exames Realizados",
          align: "center",
          value: "quantity_of_exams",
        },
        {
          text: "Fator RH",
          align: "center",
          value: "fator_rh",
        },
        {
          text: "Data da Coleta",
          align: "start",
          value: "sample_date",
        },
        {
          text: "Data da Liberação",
          align: "start",
          value: "release_date",
        },
        { text: "Ações", value: "actions", sortable: false, align: "start" },
      ],
      page: 1,
      totalUsers: 0,
      numberOfPages: 0,
      loading: false,
      options: {},
      sortBy: "name",
      filtro: {},
      donorSearch: {},
      items: [],
      loadingPDF: false,
      serologySearch: {
        name: null,
        kind_of_donor: null,
        unity: null,
        factor: null
      },
      unities: [],
      kind_of_donor: [],
      factors: [],
      loadingBTN: false,
      loadingTrashButton: false,
      menuItems: [
        { title: "Editar Grupos Sanguíneos", icon: "mdi-pencil", link: "/cadastrar-grupo-sanguineo" },
        { title: "Adicionar Grupo Sanguíneo", icon: "mdi-plus", link: "/cadastrar-grupo-sanguineo" },
        { title: "Anexos", icon: "mdi-paperclip", link: "/anexos-sorologia" },
        { title: "Imprimir/Gerar PDF", icon: "mdi-printer", link: "" },
      ],
      currentPatient: {},
      teste: false
    };
  },

  components: {
    BloodGroup
  },

  created() {
    this.getAllDependencies();
  },

  watch: {},

  computed: {
    currentUser() {
      return currentUser.getUserData()
    },

    headers() {
      return this.headersForAll
    },

    profile() {
      const profile = this.currentUser.profile
      return profileSlug(profile)
    }
  },

  methods: {
    ...mapActions([
      "changeSnackBarData",
      "changeBloodGroupsPatientData",
    ]),

    getQuantityOfExams(item) {
      return item.blood_groups && item.blood_groups.length
        ? item.blood_groups.length
        : '--';
    },

    async getAllDependencies() {
      this.unities = await getUnities();
      this.kind_of_donor = await getPatienteSituations();
      this.factors = await getFactors();
      this.search();
    },

    async handleReload() {
      await this.search();
    },

    setAction(item, data) {
      const option = item.title
      if (['Editar Grupos Sanguíneos', 'Anexos'].includes(option)) {
        this.$router.push(item.link);
        this.changeBloodGroupsPatientData(data);
      } else if (option == 'Adicionar Grupo Sanguíneo') {
        this.dialog = true;
        this.currentPatient = data
        this.changeBloodGroupsPatientData(data);
      }else{
        this.downloadDonorPdf(data)
      }
    },

    getBloodGroupSampleDate(item) {
      if (
        item.blood_groups &&
        Array.isArray(item.blood_groups) &&
        item.blood_groups.length > 0
      ) {
        return this.formatDate(item.blood_groups[0].sample_date);
      }
      return '-';
    },


    async search() {
      this.loading = true;
      this.items = await getBloodList(this.serologySearch);

      setTimeout(() => {
        this.loading = false;
        this.loadingBTN = false;
        this.menu = false;
      }, 1000);
    },

    clear() {
      this.serologySearch = {}
      this.$emit("eventname", '');

      setTimeout(() => {
        this.loadingTrashButton = true; 
        this.search();
      }, 1000);
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },

    downloadDonorPdf(item) {
      this.loadingPDF = true;

      axios.get(`/donor/pdf_serology/${item.id}`, {
        responseType: 'blob'
      })
        .then((response) => {
          this.loadingPDF = false;
          let url = window.URL.createObjectURL(new Blob([response.data]));
          let link = document.createElement('a');
          link.href = url;
          let nome = (item.name || 'paciente').trim().replace(/\s+/g, '_');
          link.setAttribute('download', `sorologia${nome}.pdf`);

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.loadingPDF = false;
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Algo deu errado!",
            bodyMessage: error.details,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.changeSnackBarData({
              status: false,
              type: "",
              titleMessage: "",
              bodyMessage: "",
              cardColor: "",
              titleIcon: "",
            });
          }, 5000);
        });
    }
  },
};
</script>

<style scoped>
.textBtn {
  color: #FFFFFF;
}
</style>